import { type ExpandedFieldStateManager } from "./ExpandedFieldStateManager";
import { type ValueInspectorRowInfo } from "./ValueInspectorRowInfo";
import { type ValuePathRoot } from "./ValuePath";
import { traverseValue } from "./traverseValue";

export function traverseCellValue(
	fieldExpander: ExpandedFieldStateManager,
	pathRoot: ValuePathRoot
): ValueInspectorRowInfo[] {
	return traverseValue(fieldExpander, [pathRoot], pathRoot.typeInfo, false);
}
